import { createApi } from '@reduxjs/toolkit/query/react';
import { networkBaseQuery } from './utils';

export const weeklyRoutesBaseApi = createApi({
  reducerPath: 'weeklyRoutesApi',
  baseQuery: networkBaseQuery,
  keepUnusedDataFor: 120,
  endpoints: () => ({})
});
